const getPackageRequestObject = (req, key, filters) => {
	let reqObj = {
		key,
		testimonials: 5,
		limit: 50,
		journalTestimonials: false,
		...filters,
	}
	return reqObj
}

export default getPackageRequestObject
